import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "scroll-to-top d-lg-none position-fixed" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "js-scroll-trigger d-block text-center text-white rounded",
    href: "#page-top"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-up" })
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "portfolio-modal modal fade",
  id: "portfolioModal1",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "portfolioModal1Label",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-xl",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "close",
        type: "button",
        "data-dismiss": "modal",
        "aria-label": "Close"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body text-center" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8" }, [
              /*#__PURE__*/_createElementVNode("h2", {
                class: "portfolio-modal-title text-secondary text-uppercase mb-0",
                id: "portfolioModal1Label"
              }, "Log Cabin"),
              /*#__PURE__*/_createElementVNode("div", { class: "divider-custom" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" }),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-icon" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" })
              ]),
              /*#__PURE__*/_createElementVNode("img", {
                class: "img-fluid rounded mb-5",
                src: "#",
                alt: ""
              }),
              /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia neque assumenda ipsam nihil, molestias magnam, recusandae quos quis inventore quisquam velit asperiores, vitae? Reprehenderit soluta, eos quod consequuntur itaque. Nam."),
              /*#__PURE__*/_createElementVNode("button", {
                class: "btn btn-primary",
                "data-dismiss": "modal"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times fa-fw" }),
                /*#__PURE__*/_createTextVNode(" Close Window ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "portfolio-modal modal fade",
  id: "portfolioModal2",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "portfolioModal2Label",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-xl",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "close",
        type: "button",
        "data-dismiss": "modal",
        "aria-label": "Close"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body text-center" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8" }, [
              /*#__PURE__*/_createElementVNode("h2", {
                class: "portfolio-modal-title text-secondary text-uppercase mb-0",
                id: "portfolioModal2Label"
              }, "Tasty Cake"),
              /*#__PURE__*/_createElementVNode("div", { class: "divider-custom" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" }),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-icon" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" })
              ]),
              /*#__PURE__*/_createElementVNode("img", {
                class: "img-fluid rounded mb-5",
                src: "#",
                alt: ""
              }),
              /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia neque assumenda ipsam nihil, molestias magnam, recusandae quos quis inventore quisquam velit asperiores, vitae? Reprehenderit soluta, eos quod consequuntur itaque. Nam."),
              /*#__PURE__*/_createElementVNode("button", {
                class: "btn btn-primary",
                "data-dismiss": "modal"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times fa-fw" }),
                /*#__PURE__*/_createTextVNode(" Close Window ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "portfolio-modal modal fade",
  id: "portfolioModal3",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "portfolioModal3Label",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-xl",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "close",
        type: "button",
        "data-dismiss": "modal",
        "aria-label": "Close"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body text-center" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8" }, [
              /*#__PURE__*/_createElementVNode("h2", {
                class: "portfolio-modal-title text-secondary text-uppercase mb-0",
                id: "portfolioModal3Label"
              }, "Circus Tent"),
              /*#__PURE__*/_createElementVNode("div", { class: "divider-custom" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" }),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-icon" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" })
              ]),
              /*#__PURE__*/_createElementVNode("img", {
                class: "img-fluid rounded mb-5",
                src: "#",
                alt: ""
              }),
              /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia neque assumenda ipsam nihil, molestias magnam, recusandae quos quis inventore quisquam velit asperiores, vitae? Reprehenderit soluta, eos quod consequuntur itaque. Nam."),
              /*#__PURE__*/_createElementVNode("button", {
                class: "btn btn-primary",
                "data-dismiss": "modal"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times fa-fw" }),
                /*#__PURE__*/_createTextVNode(" Close Window ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "portfolio-modal modal fade",
  id: "portfolioModal4",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "portfolioModal4Label",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-xl",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "close",
        type: "button",
        "data-dismiss": "modal",
        "aria-label": "Close"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body text-center" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8" }, [
              /*#__PURE__*/_createElementVNode("h2", {
                class: "portfolio-modal-title text-secondary text-uppercase mb-0",
                id: "portfolioModal4Label"
              }, "Controller"),
              /*#__PURE__*/_createElementVNode("div", { class: "divider-custom" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" }),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-icon" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" })
              ]),
              /*#__PURE__*/_createElementVNode("img", {
                class: "img-fluid rounded mb-5",
                src: "#",
                alt: ""
              }),
              /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia neque assumenda ipsam nihil, molestias magnam, recusandae quos quis inventore quisquam velit asperiores, vitae? Reprehenderit soluta, eos quod consequuntur itaque. Nam."),
              /*#__PURE__*/_createElementVNode("button", {
                class: "btn btn-primary",
                "data-dismiss": "modal"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times fa-fw" }),
                /*#__PURE__*/_createTextVNode(" Close Window ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "portfolio-modal modal fade",
  id: "portfolioModal5",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "portfolioModal5Label",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-xl",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "close",
        type: "button",
        "data-dismiss": "modal",
        "aria-label": "Close"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body text-center" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8" }, [
              /*#__PURE__*/_createElementVNode("h2", {
                class: "portfolio-modal-title text-secondary text-uppercase mb-0",
                id: "portfolioModal5Label"
              }, "Locked Safe"),
              /*#__PURE__*/_createElementVNode("div", { class: "divider-custom" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" }),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-icon" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" })
              ]),
              /*#__PURE__*/_createElementVNode("img", {
                class: "img-fluid rounded mb-5",
                src: "#",
                alt: ""
              }),
              /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia neque assumenda ipsam nihil, molestias magnam, recusandae quos quis inventore quisquam velit asperiores, vitae? Reprehenderit soluta, eos quod consequuntur itaque. Nam."),
              /*#__PURE__*/_createElementVNode("button", {
                class: "btn btn-primary",
                "data-dismiss": "modal"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times fa-fw" }),
                /*#__PURE__*/_createTextVNode(" Close Window ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "portfolio-modal modal fade",
  id: "portfolioModal6",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "portfolioModal6Label",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-xl",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "close",
        type: "button",
        "data-dismiss": "modal",
        "aria-label": "Close"
      }, [
        /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body text-center" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8" }, [
              /*#__PURE__*/_createElementVNode("h2", {
                class: "portfolio-modal-title text-secondary text-uppercase mb-0",
                id: "portfolioModal6Label"
              }, "Submarine"),
              /*#__PURE__*/_createElementVNode("div", { class: "divider-custom" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" }),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-icon" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "divider-custom-line" })
              ]),
              /*#__PURE__*/_createElementVNode("img", {
                class: "img-fluid rounded mb-5",
                src: "#",
                alt: ""
              }),
              /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Mollitia neque assumenda ipsam nihil, molestias magnam, recusandae quos quis inventore quisquam velit asperiores, vitae? Reprehenderit soluta, eos quod consequuntur itaque. Nam."),
              /*#__PURE__*/_createElementVNode("button", {
                class: "btn btn-primary",
                "data-dismiss": "modal"
              }, [
                /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times fa-fw" }),
                /*#__PURE__*/_createTextVNode(" Close Window ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_8 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_8))
}